(function () {

  'use strict';

  console.log('init');

  /* jQuery */
  global.$ = global.jQuery = require('jquery');


  require('slick');
  require('dzTabs');
  require('dzJobs');
  require('magnific');
  // require('../../../vendor/dmkzwo/contao-mv-timeline-bundle/src/Resources/public/dzTimeline');
  window.tippy = require('tippy.js').default;

  // tippy('.js-show-year', {
  //   theme: 'timeline'
  // });

  var viewportWidth;
  var breakpoint;
  var bpLevel;

  var bpInter = 480;
  var bpLevelInter = 1;
  var bpMedium = 720;
  var bpLevelMedium = 2;
  var bpLarge = 980;
  var bpLevelLarge = 3;
  var bpXlarge = 1100;
  var bpLevelXlarge = 4;
  var bpXXlarge = 1200;
  var bpLevelXXlarge = 5;

  var eventsActive = false;


  /* Foundation */
  //require('what-input');
  //require('foundation-sites');   use this to include all of foundation js

  //require('foundation-sites/dist/foundation');


  require('foundation-sites/js/foundation.core');
  //require('foundation-sites/js/foundation.abide');
  //require('foundation-sites/js/foundation.accordion');
  //require('foundation-sites/js/foundation.accordionMenu');

  require('foundation-sites/js/foundation.drilldown');
  require('foundation-sites/js/foundation.dropdown');
  require('foundation-sites/js/foundation.dropdownMenu');
  require('foundation-sites/js/foundation.equalizer');
  //require('foundation-sites/js/foundation.interchange');
  require('foundation-sites/js/foundation.magellan');
  //require('foundation-sites/js/foundation.offcanvas');
  //require('foundation-sites/js/foundation.orbit');
  require('foundation-sites/js/foundation.responsiveMenu');
  require('foundation-sites/js/foundation.responsiveToggle');
  //require('foundation-sites/js/foundation.reveal');
  //require('foundation-sites/js/foundation.slider');
  require('foundation-sites/js/foundation.sticky');
  require('foundation-sites/js/foundation.tabs');
  require('foundation-sites/js/foundation.toggler');
  //require('foundation-sites/js/foundation.tooltip');

  require('foundation-sites/js/foundation.util.box');
  require('foundation-sites/js/foundation.util.keyboard');
  require('foundation-sites/js/foundation.util.mediaQuery');
  require('foundation-sites/js/foundation.util.motion');
  require('foundation-sites/js/foundation.util.nest');
  require('foundation-sites/js/foundation.util.timerAndImageLoader');
  require('foundation-sites/js/foundation.util.touch');
  require('foundation-sites/js/foundation.util.triggers');


  // INIT
  var development = $('body').hasClass('development');
  var lang = $('html').attr('lang');

  $( document ).ready(function() {
    if (lang == 'de') {
      Foundation.Drilldown.defaults.backButton = '<li class="js-drilldown-back"><a>Zurück</a></li>';
    }

    $(document).foundation();
  });


  $(window).on('load', function () {

    //$('.main-nav li:not(.is-dropdown-submenu-parent) > a').on('click', function() {
      //alert('click');
    //});
    $('.mod_job_filter').dzJobfilter();

    $('.ce_colsetStart.equalize').on('postequalized.zf.equalizer', function() {
      $('.vertical-align-center').addClass('vac');
      $('.vac').removeClass('vertical-align-center');
      //console.log('heights updated');
    });

    updateBreakpoint();

    $('.vertical-align-center').css('position', 'relative');

    initSliders();
    $(document).generateTabs();
    initMagnific();
    initFixed();
    initLangLayer();
    initMapLayer();
    initTimeline();
    initBookingList();

    initDev();

    //$('[data-magellan-target]').on('update.zf.magellan', function() {
    //  console.log('Magellan');
    //});

    // $('#onepager-nav').on('sticky.zf.stuckto:top', function() {
    //   console.log('stick');
    //   $('.top-bar-logo, .top-bar-logo-small').removeClass('hidden');
    //   $('.top-bar-logo').addClass('hidden');
    // }).on('sticky.zf.unstuckfrom:top', function() {
    //   console.log('unstick');
    //   $('.top-bar-logo, .top-bar-logo-small').removeClass('hidden');
    //   $('.top-bar-logo-small').addClass('hidden');
    // });


  });


  // ON RESIZE



  $(window).on('resize', function () {
    updateBreakpoint();
    //Foundation.reInit('equalizer');
  });




  function updateBreakpoint() {
    viewportWidth = window.innerWidth;
    $('#screenwidth').html('viewport-width: ' + viewportWidth);
    //console.log(viewportWidth);

    if (viewportWidth < bpInter) {
      breakpoint = 'small';
      bpLevel = 0;
    } else if (viewportWidth < bpMedium) {
      breakpoint = 'inter';
      bpLevel = 1;
    } else if (viewportWidth < bpLarge) {
      breakpoint = 'medium';
      bpLevel = 2;
    } else if (viewportWidth < bpXlarge) {
      breakpoint = 'large';
      bpLevel = 3;
    } else if (viewportWidth < bpXXlarge) {
      breakpoint = 'xlarge';
      bpLevel = 4;
    } else {
      breakpoint = 'xxlarge';
      bpLevel = 5;
    }
    $('body').removeClass('small inter medium large xlarge xxlarge');
    $('body').addClass(breakpoint);

    //console.log(breakpoint);
  }


  function initSliders() {

    $('html[dir!="rtl"] .mod_article.slider:not(.slider_adapt) > div.article_inside').each(function() {
      //var el = $(this).children().prop("tagName").toLowerCase();
      //alert(el);
      //console.log('slider ltr');
      $(this).slick({
        slide: 'section, div',
        dots: true,
        adaptiveHeight: false
      });
    });

    $('html[dir!="rtl"] .mod_article.slider.slider_adapt > div.article_inside').each(function() {
      //var el = $(this).children().prop("tagName").toLowerCase();
      //alert(el);
      //console.log('slider ltr');
      $(this).slick({
        slide: 'section, div',
        dots: true,
        adaptiveHeight: true
      });
    });

    $('html[dir=rtl] .mod_article.slider:not(.slider_adapt) > div.article_inside').each(function() {
      //var el = $(this).children().prop("tagName").toLowerCase();
      //alert(el);
      //console.log('slider rtl');
      $(this).slick({
        slide: 'section, div',
        dots: true,
        adaptiveHeight: false,
        rtl: true
      });
    });

  }

  function initTimeline() {
    var startIndex = $('.js-timeline-layers > div.active').index();

    var $wrapper = $('.js-timeline-layers');

    console.log('init timeline');
    // $('.js-timeline-layers').each(function() {
      //var el = $(this).children().prop("tagName").toLowerCase();
      //alert(el);
      //console.log('slider rtl');
    $wrapper.slick({
        initialSlide: startIndex,
        slide: 'div',
        dots: false,
        adaptiveHeight: true,
        rtl: false
      });

    $wrapper.on('beforeChange', function(event, slick, currentSlide, nextSlide){
        var $currentSlide = $(slick.$slides.get(nextSlide));
        var year = $currentSlide.data('year');

        $('.ce_dz_timeline__dot').removeClass('active');
        $('#dot-' + year).addClass('active');
        centerDot(year);
      });

    // });

    $('.js-show-year').on('click', function() {
      var actIndex = $(this).index();
      var actYear = $(this).data('year');

      console.log(actYear);
      var gotoIndex = $('#tl-' + actYear).data('slick-index');
      console.log(gotoIndex);
      $wrapper.slick('slickGoTo', gotoIndex);

      centerDot(actYear);
    });

    var dotSlider = $('.ce_dz_timeline__mask');
    var isDown = false;
    var startX;
    var scrollLeft;

    dotSlider.on('mousedown', function(e) {
      isDown = true;
      dotSlider.addClass('active');
      startX = e.pageX - dotSlider.offset().left;
      scrollLeft = dotSlider.scrollLeft();
    });
    dotSlider.on('mouseleave', function(e) {
      isDown = false;
      dotSlider.removeClass('active');
    });
    dotSlider.on('mouseup', function() {
      isDown = false;
      dotSlider.removeClass('active');
    });
    dotSlider.on('mousemove', function(e) {
      if(!isDown) return;
      e.preventDefault();
      var x = e.pageX - dotSlider.offset().left;
      var walk = (x - startX) * 3; //scroll-fast
      dotSlider.scrollLeft(scrollLeft - walk);
      console.log(walk);
    });
  }

  function centerDot(year) {
    var maskWidth = $('.ce_dz_timeline__mask').width();
    var posAbsDot = parseInt($('#dot-' + year).css('left'), 10);
    var scrollLeft = Math.floor(posAbsDot - (maskWidth/2));
    console.log(scrollLeft);
    // $('.ce_dz_timeline__mask').scrollLeft(0);

    $('.ce_dz_timeline__mask').animate({scrollLeft: scrollLeft}, 800);
  }

  function initMagnific() {

    $('.popup-youtube').magnificPopup({
      disableOn: 700,
      type: 'iframe',
      mainClass: 'mfp-fade',
      removalDelay: 160,
      preloader: false,

      fixedContentPos: false
    });

  }

  function initFixed() {

    //setTimeout(function() {
      $('.fixed-bottom-right').removeClass('inactive');
    //}, 2000);


    $('.fixed-bottom-right h2').on('click', function() {
      $(this).parent().toggleClass('is-collapsed');
    });

  }

  function initDev() {

    $('#toggle-label').click(function() {
      $('body').toggleClass('dev-show-label');
    });

  }

  function initLangLayer() {
    if ($('.js-mvhome-topnav-country').length) {
      $('.js-mvhome-topnav-country').on('click', function(event) {
        event.preventDefault();
        $(this).parent().find('.mod_topnav__layer').toggle();
        $('.mod_dzmvhomecartheader').toggle();
      });
    }
  }

  function initMapLayer() {
    $('.js-map-layer').prepend('<button class="js-map-layer-close ce_imagemap__close"><i class="fa fa-close"></i></button>');

    $('.js-map-layer-close').on('click', function(event) {
      $('.js-map-layer').hide();
    });

    if ($('body.xxlarge .js-map-layer-toggle, body.xlarge .js-map-layer-toggle, body.large .js-map-layer-toggle, body.medium .js-map-layer-toggle').length) {
      $('.js-map-layer-toggle').on('click', function(event) {
        event.preventDefault();
        var mapLayerId = $(this).data('map-layer');

        var mapContainerOffset = $(this).parents('.ce_imagemap__container').offset();
        var relX = event.pageX - mapContainerOffset.left;
        var relY = event.pageY - mapContainerOffset.top;

        $('.js-map-layer').hide();
        var posX = $(this).offset().left;
        var posY = $(this).offset().top;
        console.log(posX + ' / ' + posY);

        $('#' + mapLayerId).css('top', relY);
        $('#' + mapLayerId).css('left', relX);

        $('#' + mapLayerId).toggle();

      });
    }
  }

  function initBookingList() {
    $('.js-toggle-date').on('click', function(e) {
      $(this).parent().find('.date-container').toggle();
    });
  }


}());


